<app-header></app-header>
<app-login *ngIf="showLogin" ></app-login>
<app-login-user-invited *ngIf="showLoginInvited" ></app-login-user-invited>
<app-loader></app-loader>
<!-- <div class="container-loader-app">
  <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
</div> -->

<router-outlet></router-outlet>